import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import actions from '../redux/actions/user';
import ListUsers from '../component/ListUser/ListUsers';

const mapStateToProps = (state) => ({
  users: state.user.users,
  userInfo: state.user.userInfo,
  userSystemList: state.user.userSystemList,
  userSystemInfo: state.user.userSystemInfo,
});

const mapDispatchToProps = (dispatch) => ({
  userListAction: (params, callback) => {
    dispatch(actions.userListAction(params, callback));
  },
  userInfoAction: (params, callback) => {
    dispatch(actions.userInfoAction(params, callback));
  },
  userSystemListAction: (params, callback) => {
    dispatch(actions.userSystemListAction(params, callback));
  },
  userSystemInfoAction: (params, callback) => {
    dispatch(actions.userSystemInfoAction(params, callback));
  },
  lockUser: (params, callback) => {
    dispatch(actions.lockUser(params, callback));
  },
  unlockUser: (params, callback) => {
    dispatch(actions.unlockUser(params, callback));
  },
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ListUsers));
